import { render, staticRenderFns } from "./EntregaDestinoCreate.vue?vue&type=template&id=0aef649a"
import script from "./EntregaDestinoCreate.vue?vue&type=script&lang=js"
export * from "./EntregaDestinoCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports